<div class="container my-5">
  <div class="card shadow-sm">
    <div class="card-body">
      <h2 class="card-title text-center mb-4">Contact ATEMAX via Internet/Smartphone</h2>
      <p class="card-text text-center text-blue">
        <a href="https://www.atemax.fr" target="_blank" class="link-primary">
          https://www.atemax.fr
        </a>
      </p>
      <ol class="list-group list-group-numbered mb-4">
        <li class="list-group-item">
          Cliquez sur <strong>“déjà inscrit”</strong>.
        </li>
        <li class="list-group-item">
          Entrez votre numéro d'exploitation <strong>25 *** ***</strong> dans le rectancle en dessous.
        </li>
        <li class="list-group-item">
          Cliquez sur <strong>“faire une demande”</strong> qui vient d'apparaitre et laissez-vous guider.
        </li>
      </ol>
      <p class="card-text">
        <strong>Besoin d'aide?</strong> Le service clients ATEMAX est joignable du lundi au vendredi hors jours fériés de
        <strong>8:00 à 12:00</strong> et de <strong>14:00 à 17:00</strong> au
        <a href="tel:0825771281" class="link-primary font-bold">
          0 825 771 281
        </a>
      </p>
    </div>
  </div>
</div>


<div class="container my-5">
  <h2 class="text-center mb-4">Liste des villes concernées</h2>

  <!-- Filter Section -->
  <div class="mb-4">
    <input
      type="text"
      class="form-control"
      placeholder="Rechercher par nom de commune ou code postal"
      [(ngModel)]="filterText"
      (input)="applyFilter()"
    />
  </div>

  <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 g-4">
    <div class="col p-2" *ngFor="let item of filteredTownships">
      <div class="card">
        <div class="d-flex justify-content-between align-items-center">
          <div class="card-title m-1 pl-1">{{ item.township }}</div>
          <div class="card-text pr-1">{{ item.post_code  | postcode }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
  <!-- Grid Section
  <table class="table table-bordered">
    <thead>
    <tr>
      <th>Township Name</th>
      <th>Postcode</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of filteredTownships">
      <td>{{ item.name }}</td>
      <td>{{ item.postcode }}</td>
    </tr>
    </tbody>
  </table>
</div>
-->
